var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxUncheckRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.705 3.84504C36.0561 3.13596 43.6946 5.27163 48.0798 8.70221C52.4651 12.1328 56.108 18.5613 57.0165 24.4286C57.925 30.2958 56.4408 38.8413 53.5306 43.906C50.6203 48.9706 44.6513 52.8246 39.555 54.8162C34.4587 56.8079 28.1681 57.6721 22.9529 55.8561C17.7376 54.0401 11.1667 48.7644 8.26331 43.9203C5.35993 39.0762 4.5036 32.3237 5.53259 26.7914C6.56158 21.2592 9.17491 14.3443 14.4372 10.7268C19.6996 7.10927 32.1319 5.7018 37.1066 5.0862C42.0813 4.4706 44.3049 6.62517 44.2854 7.0332M27.0438 4.18996C32.5309 3.21802 41.4491 5.28998 46.1727 8.26308C50.8962 11.2362 53.86 16.5593 55.385 22.0285C56.91 27.4978 57.4737 35.9686 55.3227 41.0784C53.1718 46.1883 47.6714 50.072 42.4793 52.6875C37.2872 55.303 29.4064 57.7754 24.17 56.7714C18.9336 55.7675 14.5417 51.4403 11.0606 46.6637C7.5796 41.8872 3.18738 33.7069 3.28379 28.1121C3.38019 22.5174 7.61958 17.1445 11.639 13.0952C15.6585 9.04597 24.8513 5.38753 27.4006 3.81649C29.9498 2.24544 26.91 3.37227 26.9348 3.66898",
    stroke: "#E63946",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxUncheckRed);
export default __webpack_public_path__ + "static/media/check-box-uncheck-red.35f1209891efd667e66a08dd213a1e28.svg";
export { ForwardRef as ReactComponent };